<div
  class="flex space-y-3xs"
  [ngClass]="{
    'border-t border-grey-200': border(),
    'pt-0!': !border(),
    'py-sm': size() === 'sm',
    'py-md': size() === 'default',
  }"
>
  @if (icon(); as icon) {
    <div
      class="relative mr-sm flex shrink-0 grow-0 place-content-center bg-grey-100 p-xs"
      [ngClass]="{
        'h-[45px] w-[45px] rounded-1 text-base': size() === 'default',
        'h-[35px] w-[35px] rounded-full text-[14px] leading-0': size() === 'sm',
      }"
    >
      <fa-icon [icon]="icon" class="-mt-px"></fa-icon>
    </div>
  }
  <div>
    <label
      class="font-semibold"
      [ngClass]="{
        'text-base': size() === 'default',
        'text-sm': size() === 'sm',
      }"
    >
      {{ label() }}
    </label>
    <div class="text-sm text-grey-700">
      <ng-content></ng-content>
    </div>
  </div>
</div>
